$(window).on('load', function() {
     $org_price= $('#price-check .price .money').text().replace('$', '');;
      $(".total-price").text($org_price);
    $(".total-price-other").text($org_price);
});


  $( document ).ready(function() {

    // $clone_step = $(".rio-options").clone(true);
    // $(".get-the-div").html($clone_step);
    // // $(".shopify-product-form .rio-options").remove();

    
    
    function hideTextOptions() {
        $('#all_text_itens').hide();
    }

    function showTextOptions() {
        $('#all_text_itens').show();
    }
    
    function hideBackground() {
        $('#all_bg_itens').hide();
    }

    function showBackground() {
        $('#all_bg_itens').show();
    }


        // ADD TO CART LOADER/SPINNER EVENT
        try {
          var atcBtns = document.querySelectorAll('.button--add-to-cart');
          if (atcBtns && atcBtns.length) {
              atcBtns.forEach(function(atcBtn){
                  atcBtn.addEventListener('click', function(e){
                      if (this.disabled === false && typeof this.dataset.label === 'string' && this.dataset.label.toLowerCase() === 'add to cart') {
                          this.innerHTML = '<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>';
                      } else {
                          console.log('no we cant change the content yet');
                      }
                  });
              });
          }            
        } catch(err) {
          console.log("ATC ERROR: Not able to process loader/spinner", err);
        }
    
        $("#tab2-1").on('click', function (e) {
           $("#later").hide(100);
          
        showTextOptions();
        showBackground();
       $("#now").show(100);
          $(".text-engraving-block").show(100);
          $("#personalization_property").val("Choose Now");
      // console.log("ready");
        e.preventDefault;
   
        $("#upload_photo_now").prop("disabled", false);
        $("#upload_photo_later").prop("disabled", true);
        // $(".purchase-details__buttons").addClass("disable");
        //   if(!$('.purchase-details__buttons.enable').length){
        //            $(".purchase-details__buttons button").html("Upload Picture First");}
    });
    $(".uploadcare--button.uploadcare--button_primary").on('click', function (e) {
        // console.log("disabled");
           $(".purchase-details__buttons button").html("Add To cart");
        $(".purchase-details__buttons").removeClass("enable");

    });
    $("#tab2-2").on('click', function (e) {
     $("#now").hide(100);
      $(".text-engraving-block").hide(100);
      $(".text-engraving").hide(100);
      $('#text-engrave-check').prop('checked', false);
      hideTextOptions();
      hideBackground();

      $("#personalization_property").val("Choose Later");
      
       $("#later").show(100);
        e.preventDefault;
        $("#upload_photo_now").attr("disabled", true);
        $("#upload_photo_later").attr("disabled", false);
        $(".button--add-to-cart").removeClass("solomedia");
        //$(".button--add-to-cart").attr("disabled", false);
        $(".purchase-details__buttons").removeClass("disable");
        $(".button--add-to-cart").html("Add to Cart");
    });
    
    //Conteo de caracteres en textarea
    var text_max = $('#countChar').attr('maxlength');
    $('#char-msg').html(text_max + ' Characters Remaining');

    $('#countChar').on('keyup', function () {
        var text_length = $('#countChar').val().length;
        var text_remaining = text_max - text_length;
        $('#char-msg').html(text_remaining + ' Characters Remaining');
        const getFontSize = (textLength) => {
            const baseSize = 40;
            //           console.log("textLength" + textLength);
            if (textLength >= 22) {
                textLength = 20
            }
            //   console.log(textLength);
            //     console.log(baseSize);
            const fontSize = (baseSize - textLength) * 0.9;
            return `${fontSize}px`
        }

        const box = document.querySelector('#show_text span');
        if (box) {
            box.style.fontSize = getFontSize(box.textContent.length);
        }

      
    $('.type-fonts').addClass('active');



    });
    $(function () {
        $('#countChar').keyup(function () {
            $('#show_text span').html(($(this).val()).replace(/\n\r?/g, '<br />'));
        });
    });
  $('.changefont').click(function () {
    let font = $(this).data('name');
    $(this).find('.btnRadio').prop('checked', true);

    $('.font').removeClass('active');
    $(this).find('.font').addClass('active');
    $('.textarea-font').css('font-family', font);
      $('#show_text').css('font-family', font);
  });

       $(".base_item_card").click(function () {
     console.log("clicked");

      if(!$(this).hasClass('active'))
      {
        var id = $(this).attr('data-id');
  
      if(id)
      {
        replaceid(id)
      }
  
        var temp = $(this).parent();
        $minus="$0";
        temp.children('.base_item_card').each(function() {
          //checking for active price
          if($(this).hasClass('active'))
          {
            $minus = $(this).find(".prod_prices").text();
          }
          $(this).removeClass("active");
        });            
        $(this).addClass("active");
        //get price and update it
       var rawPrice = $(this).find(".prod_prices").text(); // Get the text content

      // Remove the `$` symbol and trim extra spaces
      var priceWithoutDollar = rawPrice.replace("$", "").trim();
      var minus_without_dollar = $minus.replace("$", "").trim();

      $numeric_minus = parseFloat(minus_without_dollar);
      $numeric_price = parseFloat(priceWithoutDollar);

      $final_price = $(".total-price").text();
      $final_price = parseFloat($final_price);
      $final_price=$final_price-$numeric_minus;
      $final_price= $final_price+$numeric_price;

      console.log("Minus Price :",$numeric_minus);
      console.log("Add Price :",$numeric_price);

        

        
        $(".total-price").text($final_price);
        $(".total-price-other").text($final_price);
      // console.log(priceWithoutDollar); // Output the price without the `$`
        


	 }

    });

    

    $(document).on("click", ".fsp-button", function () {
    //   //empty it first in case we have the image already uploaded
      
      $("#file_stack_trigger").removeClass("file_stack_abs");
      $("#file_stack_trigger").text("Change Image");
    });

    

    $(document).on("click",".my-checkout-button",function() {
      // $clone_step = $(".photo-step").clone(true);
      // $(".photo-step").remove();
      // $(".clone-to-form").html($clone_step);
      // $(".clone-to-form").slideDown();
        
      $(".trigger_checkout_button").trigger("click");
    })
    
    
    $('.toggleButton').click(function() {
      $('.first-block-hide').toggle(); // Toggle visibility of content
      const icon = $(this).find('.drop-icon');
      icon.text(icon.text() === '▼' ? '▲' : '▼'); // Toggle icon between down and up arrows
    });

    $(document).on("click",".trigger-my-button", function(){
      $('html, body').animate({
                    scrollTop: $(".quality-size").offset().top
                }, 2000);
      $(".my-button").trigger("click");
    })

    $(document).on("click",".my-button",function(){
  
      $org_price= $('#price-check .price .money').text().replace('$', '');;
      $(".total-price").text($org_price);
      $(".total-price-other").text($org_price);
      $(".product-form-container").removeClass('hide-it');
      $(".product-form-container").slideDown(1000);
      $(".toggleButton").slideDown();

      $(".is-floating-personal").remove();
      $(".personlaize-button").remove();
      $(".first-block").toggle(); // Toggle visibility of content
      const icon = $("#drop-icon");
      icon.text(icon.text() === '▼' ? '▲' : '▼'); // Toggle icon between down and up arrows

      
      // //cloning all the step only if exists
      if ($('div.photo-step').length > 0) {
        $(".text-engraving-not-photostep").remove();
        $clone_step = $(".photo-step").clone(true);
        $(".photo-step").remove();
        // $(".product-gallery--sticky").slideUp();
        $(".product-gallery--sticky").html("");
        $(".product-gallery--sticky").html($clone_step);
        // $(".product-gallery").html($clone_step);
      }
     
      
      // $(".product-gallery--sticky").slideDown(1000);
      
      const client = filestack.init('AICGY73xCTGhWphQC7yu6z');
        const options = {
        onUploadDone: updateForm,
        maxSize: 10 * 1024 * 1024,
        accept: 'image/*',
        uploadInBackground: false,
      };
        const picker = client.picker(options);
      const fileInput = document.getElementById('fileupload');
      const btn = document.getElementById('file_stack_trigger');
        const btn_c = document.getElementsByClassName('file_stack_trigger_class')[0];
        const nameBox = document.getElementById('nameBox');
      const urlBox = document.getElementById('urlBox');
      
          if(btn){
      btn.addEventListener('click', function (e) {
        // console.log("clicked");
        e.preventDefault();
        picker.open();
      });
          }
      
        if(btn_c){
      btn_c.addEventListener('click', function (e) {
        // console.log("clicked");
        e.preventDefault();
        picker.open();
      });
          }

      var preview_ovarlay_image = "{{ img_mask.cloudinary_src }}";

var globalImg;

// function walker(records) {
//     records.forEach(function (record) {
//         var list = record.addedNodes;
//         var i = list.length - 1;

//         for (; i > -1; i--) {
//             if (list[i].nodeName === "IMG") {
//                 // Insert code here...
//                 if (list[i].classList.value.includes("uploadkit-thumbnail")) {
//                     if (globalImg != list[i].src) {
//                         globalImg = list[i].src;

//                         // SET IMAGE AND start cropper
//                         document.querySelector("#capture_full").src = globalImg.replace('300x', '2000x') + '-/grayscale/';
//                         initCropper();
//                     }
//                 }
//             }
//         }
//     });
// }
  function updateForm (result) {
  const fileData = result.filesUploaded[0];
  fileInput.value = fileData.url;
    var monochromeurl = fileData.url.replace("filestackcontent.com","filestackcontent.com/monochrome");
console.log(monochromeurl);
  const name = document.createTextNode('Selected: ' + fileData.filename);



  // If file is resizable image, resize and embed it as a thumbnail preview
  if (['jpeg', 'png'].indexOf(fileData.mimetype.split('/')[1]) !== -1) {
    const thumbnail = document.getElementById('capture_full');
    thumbnail.src = client.transform(fileData.handle, { 
      resize: { 
        width: 1000 
      },
      
    });
   initCropper();
  }
      var uploadedfile = '<input type="hidden" name="properties[Uploaded Photo]" value='+fileData.url+'>';
    
             $('.shopify-product-form').append(uploadedfile);
};



      


      if ($(window).width() < 768) {
        $(".product__images").css("margin-bottom","0");
                $("html, body").animate({
            scrollTop: $(".photo-step").offset().top
        }, 1000); // 1000ms = 1 second
      }
      else
      {
        $(".product__images").css("margin-bottom","60px");
      }
      
    
    });

    

     
$(window).scroll(function () {
    var button = $('.floating-div');
    var buttonTop = button.offset().top;
    var buttonBottom = buttonTop + button.outerHeight();
    var scrollPosition = $(window).scrollTop();

    if (buttonBottom <= scrollPosition) {
        if (!$(".product-form-container").hasClass("hide-it")) {
            button.css({
                'visibility': 'hidden',
                'opacity': '0',
            });
            $(".is-floating").fadeIn(300);
        }
    } else {
        button.css({
            'visibility': 'visible',
            'opacity': '1',
        });
        $(".is-floating").fadeOut(300);
    }
});

//for-personalization    
    
$(window).scroll(function () {
    var button = $('.my-button');
    if (button.length) {
        var buttonTop = button.offset().top;
        var buttonBottom = buttonTop + button.outerHeight();
        var scrollPosition = $(window).scrollTop();
        var windowHeight = $(window).height();

        // Check if the button is completely out of the viewport (above or below)
        if (buttonBottom < scrollPosition || buttonTop > scrollPosition + windowHeight) {
            $(".is-floating-personal").fadeIn(300);
        } else {
            $(".is-floating-personal").fadeOut(300);
        }
    }
});


        

    
    
    
});

